<div class="layout">
  <aside class="sidebar">
    <app-sidebar class="sidebar-content" />
  </aside>
  <main class="main-content">
    <router-outlet
      (activate)="onRouteActivate()"
      (deactivate)="onRouteDeactivate()"
    />
  </main>
</div>
